export default "__VITE_ASSET__DEJvlQLc__"